module.exports = __webpack_public_path__ + "img/RegistrationBg.5bf10371.png";